var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "layout-navbars-breadcrumb-user",
      style: { flex: _vm.layoutUserFlexNum },
    },
    [
      _c(
        "div",
        {
          staticClass: "layout-navbars-breadcrumb-user-icon",
          on: { click: _vm.refresh },
        },
        [
          _c("i", {
            staticClass: "el-icon-refresh-right",
            attrs: { title: "刷新" },
          }),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "layout-navbars-breadcrumb-user-icon",
          on: { click: _vm.onSearchClick },
        },
        [
          _c("i", {
            staticClass: "el-icon-search",
            attrs: { title: "菜单搜索" },
          }),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "layout-navbars-breadcrumb-user-icon",
          on: { click: _vm.onScreenfullClick },
        },
        [
          _c("i", {
            class: !_vm.isScreenfull ? "el-icon-full-screen" : "el-icon-crop",
            attrs: { title: _vm.isScreenfull ? "关全屏" : "开全屏" },
          }),
        ]
      ),
      _c(
        "el-popover",
        {
          ref: "messagePopover",
          attrs: {
            placement: "bottom",
            width: "350",
            trigger: "click",
            "popper-class": "msg-remind-popover",
          },
          on: { show: _vm.getInternalPageInfo },
        },
        [
          _c(
            "div",
            { staticClass: "msg-remind-content" },
            [
              _c("div", { staticClass: "remind-title-box" }, [
                _c("span", [_vm._v("系统消息")]),
                _c("i", {
                  staticClass: "el-icon-close",
                  on: { click: _vm.closePopover },
                }),
              ]),
              _vm.messageList.length
                ? _c(
                    "div",
                    { staticClass: "msg-list" },
                    _vm._l(_vm.messageList, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "msg-item",
                          on: {
                            click: function ($event) {
                              return _vm.goPage(item.path)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "msg-label" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                          _c("div", { staticClass: "msg-desc" }, [
                            _vm._v(_vm._s(item.message)),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _c("el-empty", {
                    attrs: { description: "暂无消息~", "image-size": 100 },
                  }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "layout-navbars-breadcrumb-user-icon",
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [
              _c(
                "el-badge",
                { staticClass: "item", attrs: { "is-dot": _vm.isDot } },
                [
                  _c("i", {
                    staticClass: "el-icon-bell",
                    attrs: { title: "站内消息" },
                  }),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm.showConsistencyChecking
        ? _c(
            "div",
            {
              staticClass: "merchant-consistency-checking",
              attrs: {
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-loading",
                attrs: { "aria-hidden": "true" },
              }),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.consistencyStatus.scanInProgress
                      ? "校验中"
                      : "等待首次校验"
                  )
                ),
              ]),
            ]
          )
        : _vm.showConsistencyAlert
        ? _c(
            "button",
            {
              staticClass: "merchant-consistency-alert",
              attrs: {
                type: "button",
                "aria-label": _vm.consistencyAlertLabel,
              },
              on: { click: _vm.openInconsistentMerchants },
            },
            [
              _c("i", {
                class:
                  _vm.consistencyStatus.state === "ERROR"
                    ? "el-icon-circle-close"
                    : "el-icon-warning-outline",
                attrs: { "aria-hidden": "true" },
              }),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.consistencyStatus.state === "ERROR"
                      ? "校验失败"
                      : "账号异常"
                  )
                ),
              ]),
              _vm.consistencyStatus.issueCount
                ? _c(
                    "span",
                    {
                      staticClass: "merchant-consistency-count",
                      attrs: {
                        role: "status",
                        "aria-atomic": "true",
                        "aria-label":
                          _vm.consistencyStatus.issueCount +
                          " 个商户账号数据不一致",
                      },
                    },
                    [_vm._v(_vm._s(_vm.consistencyBadgeCount))]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._m(0),
      _c(
        "el-dropdown",
        {
          attrs: { "show-timeout": 70, "hide-timeout": 50 },
          on: { command: _vm.onDropdownCommand },
        },
        [
          _c("span", { staticClass: "layout-navbars-breadcrumb-user-link" }, [
            _vm._v(" " + _vm._s(_vm.getUserInfos.name) + " "),
            _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
          ]),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            [
              _c("el-dropdown-item", { attrs: { command: "users" } }, [
                _vm._v("个人中心"),
              ]),
              _c("el-dropdown-item", { attrs: { command: "password" } }, [
                _vm._v("修改密码"),
              ]),
              _c(
                "el-dropdown-item",
                { attrs: { divided: "", command: "logOut" } },
                [_vm._v("退出登录")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "layout-navbars-breadcrumb-user-icon",
          on: { click: _vm.onLayoutSetingClick },
        },
        [
          _c("i", {
            staticClass: "el-icon-setting",
            attrs: { title: "布局配置" },
          }),
        ]
      ),
      _c("Search", { ref: "searchRef" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout-navbars-breadcrumb-user-icon" }, [
      _c("div", { staticClass: "platformLabel" }, [_vm._v("平台")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }